import { Component, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'scaffold-layout-sidebar',
    templateUrl: './layout-sidebar.component.html',
    styleUrls: ['./layout-sidebar.component.scss'],
    standalone: false
})
export class LayoutSidebarComponent {
  private _state: string = 'collapsed';
  private _side: 'left' | 'right' = 'left';

  @Input()
  get state(): string {
    return this._state;
  }

  set state(value: string) {
    this._state = value;
    this.updateClasses();
  }

  @Input()
  get side(): 'left' | 'right' {
    return this._side;
  }

  set side(value: 'left' | 'right') {
    this._side = value;
    this.updateClasses();
  }

  @HostBinding('class') sidebarClass: string = 'collapsed sidebar-left';

  private updateClasses(): void {
    this.sidebarClass = `${this._state} sidebar-${this._side}`;
  }
}
